let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("47FAO"), load("64Goy"), load("heWL2")]).then(() => parcelRequire('dHxkf'));